import React from 'react'
import { Image, Link, BlogButton, PostDetails } from 'newComponents'
import truncateString from '../../../utils/truncateString'
import stars from '../../../images/static-stars.jpg'
import './styles.scss'

const FeaturedPost = (props) => {
  const { data, className, uid: slug, dataString } = props
  if (!data) return null
  const { title, featured_image: heroImage, categories, excerpt, timestamp, author, body } = data
  // content checks
  const titleText = title?.text
  // const hasImage = heroImage?.url
  const primaryCategory = categories.length > 0 ? categories[0] : ''
  const categoryUid = primaryCategory?.category?.uid
  const excerptText = excerpt?.text

  // data formatting
  const categoryUidToName = {
    podcast: 'PODCASTS',
    'team-news': 'TEAM & NEWS'
  }

  const formattedCategory = categoryUidToName[categoryUid] || categoryUid.toUpperCase().replace(/-/g, ' ')
  const { primary } = body[0]
  const { wysiwyg } = primary
  const { text } = wysiwyg
  const excerptBackup = truncateString(text, 270)
  return (
    <section className={`featured-post ${className}`}>
      <div className="featured-post-container">
        {/* CATEGORY AND TITLE */}
        {categoryUid && (
          <Link to={`/blog/category/${categoryUid}`} className="featured-post-category">
            <span>{formattedCategory}</span>
          </Link>
        )}
        {titleText && (
          <Link to={`/blog/${slug}`} className="featured-post-title">
            <span>{truncateString(titleText, 90)}</span>
          </Link>
        )}
        {/* AUTHOR, DATE, READTIME */}
        <PostDetails timestamp={timestamp} author={author} dataString={dataString} />
        {/* FEATURED IMAGE */}
        <Link to={`/blog/${slug}`} className="featured-post-image-container">
          <Image image={heroImage?.localFile || heroImage?.url || stars} className="featured-post-image" />
        </Link>
        {/* EXCERPT AND BUTTON */}
        <span className="featured-post-excerpt">{excerptText || excerptBackup}</span>
        <BlogButton to={slug}>READ NOW</BlogButton>
      </div>
    </section>
  )
}

export default FeaturedPost
